/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsCart = {
  init: function ($section) {

    // Add settings from schema to current object
    //window.PXUTheme.jsCart = $.extend(this, window.PXUTheme.getSectionData($section));

    this.$section = $section;

    $(document).on('click', '[data-cart-page-delete]', function (e) {
      e.preventDefault();
      const lineID = $(this).data('line-item-key');
      window.PXUTheme.jsCart.removeFromCart(lineID);

      return false;
    });

    // Prevent the ajax cart form from being submitted when pressing the "Enter" key
    $('#cart_form').keydown(function(e){
      if (e.keyCode == 13) {
        e.preventDefault();
        return false;
      }
    });
  },
  removeFromCart: function (lineID) {
    const $cartItem = window.PXUTheme.jsCart.$section.find(`[data-line-item="${lineID}"]`);

    $cartItem.css('opacity', '0.5');

    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=0&line=' + lineID,
      dataType: 'json',
      success: function (cart) {

        $cartItem.addClass('animated zoomOut')
        $cartItem.remove();

        window.PXUTheme.jsCart.updateView(cart, lineID);

        if (typeof window.PXUTheme.jsAjaxCart !== 'undefined') {
          window.PXUTheme.jsAjaxCart.updateView();
        }
      },
      error: function (XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
      }
    });
  },
  updateFreeShippingBar: function ($freshSection) {
    // Swap the free-shipping progress bar with freshly rendered markup,
    // preserving the CSS width transition so the fill animates to its new value.
    const $current = $('.free-shipping-bar-section');
    if (!$current.length || !$freshSection || !$freshSection.length) {
      return;
    }

    const prevWidth = $current.find('.progress-bar-fill').css('width'); // computed px
    $current.html($freshSection.html());

    const $fill = $current.find('.progress-bar-fill');
    if ($fill.length && prevWidth) {
      const targetWidth = $fill[0].style.width; // e.g. "42%"
      $fill.css('width', prevWidth); // start from the previous value
      $fill[0].offsetHeight; // force reflow so the next change animates
      $fill.css('width', targetWidth);
    }
  },
  refreshFreeShippingBar: function () {
    // Standalone refresh via the Section Rendering API. Used when the cart
    // becomes empty and no full /cart markup is fetched for re-use.
    const $current = $('.free-shipping-bar-section');
    if (!$current.length) {
      return;
    }
    const sectionId = $current.attr('id').replace('shopify-section-', '');
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    $.ajax({
      url: root + '?section_id=' + encodeURIComponent(sectionId),
      cache: false,
      dataType: 'html',
      success: function (sectionHTML) {
        const $fresh = $('<div></div>').html(sectionHTML).find('.free-shipping-bar-section');
        window.PXUTheme.jsCart.updateFreeShippingBar($fresh);
      }
    });
  },
  updateView: function (cart, lineID) {

    if (cart.item_count > 0) {
      $.ajax({
        dataType: "json",
        async: false,
        cache: false,
        dataType: 'html',
        url: "/cart",
        success: function (html) {

          // Parse the fetched cart markup once and reuse it for every lookup.
          // Inserted nodes are cloned so the parsed fragment stays intact
          // (replaceWith/before/after would otherwise move nodes out of it).
          const $dom = $(html);

          if (lineID !== null) {

            const updatedItems = $dom.find('.cart__item-list .cart__card');
            const currentItems = $('.cart__item-list .cart__card');

            // Checks if BOGO applied and there is a change in the number of line items
            if (updatedItems.length != currentItems.length){
              // Re-append cart items
              $('.cart__item-list').replaceWith($dom.find('.cart__item-list').clone());
            }

            $(currentItems).each(function(index, element){
              $(element).attr('data-line-item', (index + 1));
              $(element).find('[data-line-item-key]').attr('data-line-item-key', (index + 1));
            })

            const $updatedLine = $dom.find(`[data-line-item="${lineID}"]`);
            const itemTotal = $updatedLine.find('.cart__total').clone();
            const quantityInput = $updatedLine.find('.quantity-input').clone();
            const itemPrice = $updatedLine.find('.cart__price').clone();

            $(`[data-line-item="${lineID}"]`).find('.cart__total').replaceWith(itemTotal);
            $(`[data-line-item="${lineID}"]`).find('.quantity-input').replaceWith(quantityInput);
            $(`[data-line-item="${lineID}"]`).find('.cart__price').replaceWith(itemPrice);

          }

          const subtotal = $dom.find('.cart__subtotal-container').clone();
          const discounts = $dom.find('.cart__discounts').clone();
          const savings = $dom.find('.cart__total-savings').clone();

          $('.cart__subtotal-container').replaceWith(subtotal);

          if (discounts.length > 0 && $('.cart__discounts').length < 1) {
            $('.cart__subtotal-container').before(discounts);
          } else {
            $('.cart__discounts').replaceWith(discounts);
          }

          if (savings.length > 0 && $('.cart__total-savings').length < 1) {
            $('.cart__subtotal-container').after(savings);
          } else {
            $('.cart__total-savings').replaceWith(savings);
          }

          $('[data-bind="itemCount"]').text(cart.item_count);

          // Re-render the free-shipping progress bar from the freshly fetched
          // cart markup so it reflects the new totals live (quantity +/- & delete).
          window.PXUTheme.jsCart.updateFreeShippingBar($dom.find('.free-shipping-bar-section'));

        }
      });

    } else {
      $('.cart__empty-cart-message').removeClass('is-hidden');
      $('.cart__form').addClass('is-hidden');
      $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
      $('[data-bind="itemCount"]').text('0');

      // Cart is now empty: refresh the bar to its zero state.
      window.PXUTheme.jsCart.refreshFreeShippingBar();
    }

  },
  unload: function ($section) {
    // Clear event listeners in theme editor
    $('[data-cart-page-delete]').off();
    $('#cart_form').off();
  }
}

/******/ })()
;